function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 0H3a3 3 0 00-3 3v15.5a3 3 0 003 3h6.5a1 1 0 000-2H3a1 1 0 01-1-1V5.251A.25.25 0 012.249 5H21.75a.25.25 0 01.25.25v5.25a1 1 0 002 0V3a3 3 0 00-3-3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 13a5.5 5.5 0 105.5 5.5 5.5 5.5 0 00-5.5-5.5zm3.316 4.043l-3.218 4.478a.974.974 0 01-.711.401 1.039 1.039 0 01-.079.003.973.973 0 01-.688-.285l-1.835-1.835a.973.973 0 011.376-1.376l1.025 1.026 2.551-3.549a.973.973 0 111.58 1.137z"
});

function SvgSpMenuAppInSync(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "spMenuAppInSync.aa9f1.svg";
export { SvgSpMenuAppInSync as ReactComponent };